import * as actions from './toast.actions'

const initialState = {
  toastProps: null,
}

const actionsMap = {
  [actions.ADD_TOAST]: (state, action) => {
    return {
      ...state,
      toastProps: action.data,
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
